import EventBusProvider from './event-bus-provider'
import { useConnectionContext } from './context'
import useCorvusEvent from './hooks/use-event'
import useEvent from './hooks/use-event-list'
import useEventsOnViewLoad from './hooks/use-events-on-view-load'

const useEffectWithEvent = useEventsOnViewLoad

export {
  useConnectionContext,
  useCorvusEvent,
  useEvent as useCorvusEventList,
  useEvent,
  useEventsOnViewLoad,
  useEffectWithEvent,
  EventBusProvider
}
